import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ArchitectingTheFutureOfBusiness from "./sections/ArchitectingTheFutureOfBusiness";
import TheIntelligenceEdge from "./sections/TheIntelligenceEdge";
import StrategicPillars from "./sections/StrategicPillars";
import WhyLeadersChooseFmc from "./sections/WhyLeadersChooseFmc";
import VoicesOfSuccess from "./sections/VoicesOfSuccess";
import BeginYourTransformation from "./sections/BeginYourTransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ArchitectingTheFutureOfBusiness />
      <TheIntelligenceEdge />
      <StrategicPillars />
      <WhyLeadersChooseFmc />
      <VoicesOfSuccess />
      <BeginYourTransformation />
      <Footer />
    </div>;
}